/**
 * Base for error kinds recognised across bundle boundaries. `instanceof` is
 * unreliable there — server and tasks bundle their own copy of a shared class —
 * so classification reads the `_tag` literal instead.
 */
export abstract class TaggedError<Tag extends string = string> extends Error {
  readonly _tag: Tag;

  constructor(tag: Tag, message: string, options?: ErrorOptions) {
    super(message, options);
    this._tag = tag;
    this.name = tag;
  }

  static is(value: unknown): value is TaggedError {
    return (
      value instanceof Error &&
      "_tag" in value &&
      typeof value._tag === "string"
    );
  }

  static hasTag<Expected extends string>(
    value: unknown,
    tag: Expected,
  ): value is TaggedError<Expected> {
    return TaggedError.is(value) && value._tag === tag;
  }
}
